import mainStyle from '../org-management.module.scss';
import LinkerWithA from 'components/LinkerWithA';
import Icon from 'components/Icon';

import { useEffect, useState } from 'react';
import { size, cloneDeep } from "lodash"
import { userPriv, userInvalid } from "utils/privilege.util";

import Nuclias from "const/nuclias";
const { organizationType, userType, userPrivilege } = Nuclias;

const TagSiteNodeContainer = ({
  label,
  orgLevel,
  isChildrenHide,
  children,
  onNameClick
}) => {

  const [isHide, setChildrenHide] = useState(!!isChildrenHide);
  const hideCollapse = orgLevel === organizationType.site || !children ? 'd-none' : '';
  const iconClass = isHide ? 'icon-expand' : 'icon-collapse';
  const iconTagSite = orgLevel === organizationType.site ? 'icon-site' : 'icon-tag';

  useEffect(() => {
    setChildrenHide(isChildrenHide);
  }, [isChildrenHide]);

  return (
    <div className={mainStyle['child-node-container']}>
      <div className={mainStyle['node']}>
        <div>
          <div className={mainStyle['tree-up-line']}></div>
          <div className={mainStyle['tree-down-line']}></div>
        </div>
        <Icon
          className={`${iconClass} ${hideCollapse}`}
          onClick={() => setChildrenHide(!isHide)}
        />
        <Icon className={`${iconTagSite} ${mainStyle['icon-tag-site']}`} />
        <div className='ms-1'>
          <LinkerWithA
            label={label}
            href='#'
            className='fw-normal linker-blue linker-blue-hover text-decoration-none'
            onClick={e => {
              e.preventDefault();
              onNameClick();
            }}
          />
        </div>
      </div>
      {!isHide && children}
    </div>
  );
};

const OrgTreeTreeView = ({
  info,
  treeData,
  viewStatus,
  handleModals
}) => {

  const [treeViewInfo, setTreeViewInfo] = useState({});
  const orgInfo = {
    orgType: organizationType.org,
    id: info?.orgDs?.id,
    name: info?.orgDs?.name,
    actions: {
      createSite: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
      createTag: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
      canEdit: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
      canDelete: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag)
    }
  }

  const init = () => {
    setTreeViewInfo({ ...treeViewInfo, moreIndex: treeData.moreIndexList })
  }

  const printMap = (node) => {
    if (!node) return []

    const list = []
    for (const [index, item] of node.entries()) {
      list.push(
        <TagSiteNodeContainer
          key={`${item.orgType}_${index}`}
          label={item.name}
          orgLevel={item.orgType}
          isChildrenHide={!!viewStatus?.collapse}
          onNameClick={() => handleModals({ modal: 'preview', status: true, type: null, editObj: item })}
        >
          {item.childs && printMap(item.childs)}
        </TagSiteNodeContainer>
      )
      if (size(treeViewInfo?.moreIndex) > 0 &&
        item.id === treeViewInfo?.moreIndex[0].id && item.orgType === organizationType.site) {
        break
      }
    }
    return list
  }

  const getMoreSite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const newList = cloneDeep(treeViewInfo.moreIndex)
    newList.splice(0, 1)
    setTreeViewInfo({ ...treeViewInfo, moreIndex: newList })
  }

  useEffect(() => {
    if (size(treeData) > 0) init()
  }, [treeData]);

  return (
    <div className={mainStyle['tree-view-container']}>
      <div className={mainStyle['org-node-container']}>
        <Icon className='icon-org me-2' />
        <LinkerWithA
          label={orgInfo?.name}
          href='#'
          className='fw-normal text-decoration-underline linker-red-hover'
          onClick={e => {
            e.preventDefault();
            handleModals({ modal: 'preview', status: true, type: null, editObj: orgInfo })
          }}
        />
      </div>
      {treeData?.treeObj && printMap(treeData.treeObj)}

      {(treeViewInfo?.moreIndex && size(treeViewInfo?.moreIndex) > 0) &&
        <div className={mainStyle['more-site-link']}>
          <LinkerWithA
            label={'0658f6ed5e'}
            href="#"
            className={`linker-blue show-more text-decoration-underline`}
            onClick={(e) => getMoreSite(e)}
          />
        </div>
      }
    </div>
  );
};

export default OrgTreeTreeView;